import type { ButtonHTMLAttributes, ReactNode } from 'react'

type LoadingButtonVariant = 'primary' | 'ghost'

type LoadingButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  isLoading?: boolean
  loadingLabel?: string
  variant?: LoadingButtonVariant
  children: ReactNode
}

export function LoadingButton({
  isLoading = false,
  loadingLabel,
  variant = 'primary',
  children,
  className = '',
  disabled,
  type = 'button',
  ...props
}: LoadingButtonProps) {
  const label = loadingLabel ?? (typeof children === 'string' ? children : '処理中…')

  return (
    <button
      type={type}
      className={[
        'btn',
        `btn-${variant}`,
        'btn--loading-effect',
        isLoading ? 'is-loading' : '',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
      disabled={disabled || isLoading}
      aria-busy={isLoading}
      {...props}
    >
      <span className="btn__content">
        {isLoading ? <span className="btn__spinner" aria-hidden="true" /> : null}
        <span className="btn__label">{isLoading ? label : children}</span>
      </span>
    </button>
  )
}
